import { getAuthorizationSessionHeader } from 'api/utils/getAuthorizationSessionHeader'
import { AxiosError } from 'axios'

import { OctaneLogger } from '../../integrations/datadog/OctaneLogger'
import { axiosApi } from '../fetcher'

interface SessionResponse {
    mfa_time_left: number
    was_recently_authenticated: boolean
}

export interface Session {
    mfaTimeLeft: number
    wasRecentlyAuthenticated: boolean
}

// Use axiosApi (relative URL + baseURL override) instead of the global axios
// instance. The global sandboxVariantRoutingInterceptor rewrites absolute URLs
// that match API_BASE_URL to the active variant origin; that rewrite is correct
// for most requests but breaks session checks, which must go to whichever LOS
// origin actually owns the current session cookie (main or variant). axiosApi
// handles this via its own baseURL interceptor in fetcher.ts, which correctly
// routes to the variant when one is active without touching the URL of requests
// that should stay on the main LOS.
export default async function getCurrentSession() {
    try {
        const data = await axiosApi.get<SessionResponse>(
            'v3/auth/sessions/current/',
            {
                headers: {
                    Authorization: getAuthorizationSessionHeader(),
                },
            },
        )

        return {
            mfaTimeLeft: data.mfa_time_left,
            wasRecentlyAuthenticated: data.was_recently_authenticated,
        } as Session
    } catch (error) {
        const axiosError = error as AxiosError

        OctaneLogger.axiosError(
            `Failed to get current session: ${axiosError.message}`,
            axiosError,
        )

        throw new Error(axiosError.message)
    }
}
